import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN
} from '@spartacus/core'
import { Wishlist } from '../../models'
import { MbWishlistAdapter } from '../connectors/mb-wishlist.adapter'
import { MB_WISHLIST_NORMALIZER } from '../converters'

@Injectable({
  providedIn: 'root'
})
export class MbOccWishlistAdapter implements MbWishlistAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService) { }

  loadDefaultWishlist (userId: string) {
    const url = this.occEndpoints.buildUrl('wishlist', {
      urlParams: { userId },
    })
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }
    return this.http.get<Wishlist>(url, { headers }).pipe(
      this.converter.pipeable(MB_WISHLIST_NORMALIZER)
    )
  }

  addEntryToWishlist (productCode: string, userId: string) {
    const url = this.occEndpoints.buildUrl('updateWishlist', {
      urlParams: { userId: userId, productCode: productCode },
    })
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }
    return this.http.post(url, { headers }).pipe(
      this.converter.pipeable(MB_WISHLIST_NORMALIZER)
    )
  }

  removeEntryFromWishlist (productCode: string, userId: string) {
    const url = this.occEndpoints.buildUrl('updateWishlist', {
      urlParams: { userId: userId, productCode: productCode },
    })
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }
    return this.http.delete(url, { headers }).pipe(
      this.converter.pipeable(MB_WISHLIST_NORMALIZER)
    )
  }
}
